// PayPal (live) for the agent tech fee. Not secrets: the client id is public
// by design and the plan id is visible in every checkout. The server has its
// own copy in supabase/functions/_shared/paypal.ts; keep the two in step.
export const PAYPAL_CLIENT_ID = 'ATtj_NJnn5SKOawKy6HHPJeINRcEYnHQ-CXYitQ2i3tZ6cUlp0Dr_Wteixbdwdxrx15Q6i6-r-E2kKU-'
export const TECH_FEE_PLAN_ID = 'P-1MC02435GK990015VMAWVK5Y'
